import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, Transition as _Transition } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = { class: "d-flex" };
const _hoisted_7 = { class: "checkbox-aligned-buttons" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* HOISTED */);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Archive", -1 /* HOISTED */);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Restore", -1 /* HOISTED */);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* HOISTED */);
const _hoisted_16 = {
    key: 0,
    class: "form-contents"
};
const _hoisted_17 = { class: "row" };
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_19 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_20 = { class: "clearfix" };
const _hoisted_21 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("label", null, "Company", -1 /* HOISTED */);
const _hoisted_23 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_24 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tSystem *\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_26 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tLocation\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_28 = { class: "clearfix" };
const _hoisted_29 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tType *\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_31 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tDate *\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" }, null, -1 /* HOISTED */);
const _hoisted_34 = { class: "clearfix" };
const _hoisted_35 = { class: "col-xs-12 col-sm-12 bottom10" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tComment *\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_37 = { class: "float-end" };
const _hoisted_38 = { id: "current" };
const _hoisted_39 = { id: "maximum" };
const _hoisted_40 = {
    key: 1,
    class: "clearfix card"
};
const _hoisted_41 = { class: "clearfix card-header" };
const _hoisted_42 = { class: "d-flex float-start" };
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("h2", { class: "m-0 me-3" }, "Alarms", -1 /* HOISTED */);
const _hoisted_44 = { style: { "margin-top": "2px" } };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("label", { class: "m-0" }, "Active: ", -1 /* HOISTED */);
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("label", { class: "m-0" }, " Total: ", -1 /* HOISTED */);
const _hoisted_47 = { class: "float-end" };
const _hoisted_48 = {
    key: 0,
    class: "clearfix card-body p-0"
};
const _hoisted_49 = { class: "card bg-white data-grid event-alarms-grid overflow-x-auto m-0" };
const _hoisted_50 = { class: "table table-hover bottom0 border-collapse-separate" };
const _hoisted_51 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "alarm-border" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tTime\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tLocation\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tDescription\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tState\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tValue\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_52 = { class: "text-end" };
const _hoisted_53 = {
    key: 2,
    class: "clearfix card"
};
const _hoisted_54 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix card-header" }, [
    /*#__PURE__*/ _createElementVNode("h2", { class: "m-0 me-3" }, "Alarm Event")
], -1 /* HOISTED */);
const _hoisted_55 = { class: "card-body" };
const _hoisted_56 = { style: { "margin-top": "2px" } };
const _hoisted_57 = /*#__PURE__*/ _createElementVNode("label", { class: "m-0" }, "Event Type: ", -1 /* HOISTED */);
const _hoisted_58 = /*#__PURE__*/ _createElementVNode("label", { class: "m-0" }, "When first alarm was raised: ", -1 /* HOISTED */);
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("label", { class: "m-0" }, "When last alarm was raised: ", -1 /* HOISTED */);
const _hoisted_60 = { class: "mt-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_button = _resolveComponent("b-button");
    const _component_AlertComponent = _resolveComponent("AlertComponent");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_form_textarea = _resolveComponent("b-form-textarea");
    const _component_router_link = _resolveComponent("router-link");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", {
                    class: _normalizeClass({ 'red-text': _ctx.isLogArchived })
                }, _toDisplayString(_ctx.pageTitle), 3 /* TEXT, CLASS */)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_b_form_checkbox, {
                                class: "ms-2",
                                style: { "padding-top": "8px" },
                                modelValue: _ctx.log.notifySiteContactGroup,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.log.notifySiteContactGroup) = $event)),
                                size: "lg"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\tNotify\r\n\t\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue"])
                        ])), [
                            [_directive_standard_or_higher]
                        ]),
                        _createTextVNode(),
                        _createVNode(_component_b_button, {
                            class: "ms-2",
                            type: "button",
                            variant: "primary",
                            onClick: _ctx.save
                        }, {
                            default: _withCtx(() => [
                                _hoisted_8,
                                _hoisted_9
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]),
                        _createTextVNode(),
                        (!_ctx.isNewLog && !_ctx.isLogArchived)
                            ? (_openBlock(), _createBlock(_component_b_button, {
                                key: 0,
                                class: "ms-2",
                                type: "button",
                                variant: "danger",
                                onClick: _ctx.archive
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_10,
                                    _hoisted_11
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (!_ctx.isNewLog && _ctx.isLogArchived)
                            ? (_openBlock(), _createBlock(_component_b_button, {
                                key: 1,
                                class: "ms-2",
                                type: "button",
                                variant: "warning",
                                onClick: _ctx.restore
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_12,
                                    _hoisted_13
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        _createVNode(_component_b_button, {
                            class: "ms-2",
                            type: "button",
                            variant: "secondary",
                            onClick: _ctx.goBack
                        }, {
                            default: _withCtx(() => [
                                _hoisted_14,
                                _hoisted_15
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        (_ctx.loaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_AlertComponent, { msg: _ctx.msg }, null, 8 /* PROPS */, ["msg"])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_CollapsibleForm, null, {
                            default: _withCtx(() => [
                                _withDirectives(_createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                        _hoisted_22,
                                        _createTextVNode(),
                                        _createVNode(_component_multiselect, {
                                            name: "company",
                                            modelValue: _ctx.company,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.company) = $event)),
                                            options: _ctx.companies,
                                            "track-by": "companyId",
                                            label: "companyName",
                                            showLabels: false,
                                            placeholder: "Any company"
                                        }, {
                                            noResult: _withCtx(() => [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "options"])
                                    ])
                                ], 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.companies && _ctx.companies.length > 1]
                                ]),
                                _createTextVNode(),
                                (_ctx.systems.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        _createElementVNode("div", _hoisted_24, [
                                            _hoisted_25,
                                            _createTextVNode(),
                                            _createVNode(_component_multiselect, _mergeProps(_ctx.systemVal, {
                                                name: "system",
                                                modelValue: _ctx.system,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.system) = $event)),
                                                options: _ctx.visibleSystems,
                                                "track-by": "systemId",
                                                label: "displayName",
                                                showLabels: false,
                                                placeholder: "Any system",
                                                class: ['multiselect-small', _ctx.errors && _ctx.errors.system && _ctx.attemptedSave ? 'is-invalid' : '']
                                            }), {
                                                noResult: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 16 /* FULL_PROPS */, ["modelValue", "options", "class"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_26, [
                                            _hoisted_27,
                                            _createTextVNode(),
                                            _createVNode(_component_multiselect, {
                                                modelValue: _ctx.component,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.component) = $event)),
                                                options: _ctx.systemComponents,
                                                "track-by": "componentId",
                                                label: "displayName",
                                                showLabels: false,
                                                placeholder: "Any location",
                                                class: "multiselect-small"
                                            }, {
                                                noResult: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "options"])
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                        _hoisted_30,
                                        _createTextVNode(),
                                        _createVNode(_component_multiselect, _mergeProps(_ctx.typeVal, {
                                            name: "logType",
                                            modelValue: _ctx.logType,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.logType) = $event)),
                                            options: _ctx.logTypesVisible,
                                            "track-by": "logTypeId",
                                            label: "logTypeName",
                                            showLabels: false,
                                            placeholder: "Any type",
                                            class: ['multiselect-small', _ctx.errors && _ctx.errors.type && _ctx.attemptedSave ? 'is-invalid' : ''],
                                            disabled: _ctx.logTypeId > 2
                                        }), {
                                            noResult: _withCtx(() => [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 16 /* FULL_PROPS */, ["modelValue", "options", "class", "disabled"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_31, [
                                        _hoisted_32,
                                        _createTextVNode(),
                                        _createVNode(_component_b_input_group, {
                                            class: _normalizeClass(['clearfix bottom0', _ctx.errors && _ctx.errors.date && _ctx.attemptedSave ? 'is-invalid' : ''])
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_flat_pickr, _mergeProps(_ctx.dateVal, {
                                                    name: "whenEntered",
                                                    modelValue: _ctx.log.whenEntered,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.log.whenEntered) = $event)),
                                                    class: "form-control",
                                                    config: _ctx.datePickerConfig
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "config"]),
                                                _createTextVNode(),
                                                _createVNode(_component_b_input_group_append, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_b_button, {
                                                            type: "button",
                                                            variant: "outline-secondary",
                                                            "data-toggle": ""
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _hoisted_33
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        })
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["class"])
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                        _hoisted_36,
                                        _createTextVNode(),
                                        _createVNode(_component_b_form_textarea, _mergeProps(_ctx.commentVal, {
                                            name: "notes",
                                            modelValue: _ctx.log.notes,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.log.notes) = $event)),
                                            rows: "5",
                                            class: { 'is-invalid': _ctx.errors && _ctx.errors.comment && _ctx.attemptedSave },
                                            maxlength: _ctx.maxCommentLength
                                        }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "maxlength"]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.getCommentLength), 1 /* TEXT */),
                                            _createTextVNode(),
                                            _createElementVNode("span", _hoisted_39, "/ " + _toDisplayString(_ctx.maxCommentLength), 1 /* TEXT */)
                                        ])
                                    ])
                                ]),
                                _createTextVNode(),
                                (_ctx.divAlarmsVisible)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                        _createElementVNode("div", _hoisted_41, [
                                            _createElementVNode("div", _hoisted_42, [
                                                _hoisted_43,
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_44, [
                                                    _hoisted_45,
                                                    _createTextVNode(" " + _toDisplayString(_ctx.getActiveAlarmsCount()) + " |\r\n\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                    _hoisted_46,
                                                    _createTextVNode(" " + _toDisplayString(_ctx.getTotalAlarmsCount()), 1 /* TEXT */)
                                                ])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_47, [
                                                _createElementVNode("a", {
                                                    class: "collapse-link",
                                                    onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.alarmDetailsVisible = !_ctx.alarmDetailsVisible))
                                                }, [
                                                    _createElementVNode("i", {
                                                        class: _normalizeClass(_ctx.alarmDetailsVisible ? 'fa fa-chevron-up' : 'fa fa-chevron-down')
                                                    }, null, 2 /* CLASS */)
                                                ])
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createVNode(_Transition, { name: "slide" }, {
                                            default: _withCtx(() => [
                                                (_ctx.alarmDetailsVisible)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                        _createElementVNode("div", _hoisted_49, [
                                                            _createElementVNode("table", _hoisted_50, [
                                                                _hoisted_51,
                                                                _createTextVNode(),
                                                                _createElementVNode("tbody", null, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.log.alarms, (item) => {
                                                                        return (_openBlock(), _createElementBlock("tr", {
                                                                            class: _normalizeClass(['alarm', _ctx.alarmClass(item)])
                                                                        }, [
                                                                            _createElementVNode("td", null, [
                                                                                _createVNode(_component_router_link, {
                                                                                    to: { name: 'alarms', query: { 'alarmId': item.alarmId } },
                                                                                    class: "blue"
                                                                                }, {
                                                                                    default: _withCtx(() => [
                                                                                        _createTextVNode(_toDisplayString(_ctx.formatDateTime(item.whenRaised)), 1 /* TEXT */)
                                                                                    ]),
                                                                                    _: 2 /* DYNAMIC */
                                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                                                            ]),
                                                                            _createTextVNode(),
                                                                            _createElementVNode("td", null, _toDisplayString(item.componentName), 1 /* TEXT */),
                                                                            _createTextVNode(),
                                                                            _createElementVNode("td", null, _toDisplayString(item.alarmDefinitionName), 1 /* TEXT */),
                                                                            _createTextVNode(),
                                                                            _createElementVNode("td", null, _toDisplayString(_ctx.getAlarmState(item)), 1 /* TEXT */),
                                                                            _createTextVNode(),
                                                                            _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.getAlarmValue(item)), 1 /* TEXT */)
                                                                        ], 2 /* CLASS */));
                                                                    }), 256 /* UNKEYED_FRAGMENT */))
                                                                ])
                                                            ])
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (_ctx.divEventVisible)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                        _hoisted_54,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_55, [
                                            _createElementVNode("div", _hoisted_56, [
                                                _createElementVNode("div", null, [
                                                    _hoisted_57,
                                                    _createTextVNode(" " + _toDisplayString(_ctx.log.event.eventTypeName), 1 /* TEXT */)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("div", null, [
                                                    _hoisted_58,
                                                    _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.log.event.whenFirstAlarmRaised)), 1 /* TEXT */)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("div", null, [
                                                    _hoisted_59,
                                                    _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.log.event.whenLastAlarmRaised)), 1 /* TEXT */)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_60, [
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'events', params: { 'eventId': _ctx.log.event.eventId } },
                                                        class: "blue"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tView Alarm Event\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["to"])
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Wait..."
        }, null, 8 /* PROPS */, ["visible"])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
